import React from "react";
import PropTypes from "prop-types";
import Fields from "../../json/FoodTypeFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

/**
 * EditFoodTypeForm — Presentational component for the food type edit form.
 */
const EditFoodTypeForm = ({
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
}) => {
    const { formdata } = Fields;
    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>Edit Food Categories</HeadingOne>
        }>
            {formdata.map((field) => {
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Update"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

EditFoodTypeForm.propTypes = {
    values: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};

export default EditFoodTypeForm;
